import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {RecipientStopInfo} from "../model/rideInfo";
import {delayInMinutes, etaInMinutes} from "./timeUtils";

export function StopStatusInfo({stop}: {stop: RecipientStopInfo}) {
    const {formatRelativeTime, formatTime} = useIntl();
    if (stop.kind === "PICKUP") {
        switch (stop.status) {
            case "IN_QUEUE":
            case "DELIVERING":
                const inMinutes = etaInMinutes(stop.eta);

                if (inMinutes == null || stop.eta == null) {
                    return <FormattedMessage id="pickup_arriving_no_time" />;
                } else if (inMinutes <= -1) {
                    const delay = delayInMinutes(stop.eta);
                    return <FormattedMessage id="pickup_delay" values={{delay}} />;
                } else if (inMinutes <= 0) {
                    return <FormattedMessage id="delivery_arriving_soon" />;
                } else if (inMinutes <= 10) {
                    const time = formatRelativeTime(inMinutes, "minute");
                    return <FormattedMessage id="pickup_arriving_time" values={{time}} />;
                } else {
                    const time = formatTime(new Date(stop.eta));
                    return <FormattedMessage id="pickup_arriving_time_at" values={{time}} />;
                }
            case "DELIVERED":
                return <FormattedMessage id="pickup_finished" />;
            case "UNDELIVERED":
                return <FormattedMessage id="pickup_undelivered" />; // Should not happen in case of pickup stop
            case "ARRIVED":
                return <FormattedMessage id="pickup_arrived" />;
            case "CANCELLED":
                return <FormattedMessage id="pickup_cancelled" />;
        }
    }
    switch (stop.status) {
        case "IN_QUEUE":
        case "DELIVERING":
            const inMinutes = etaInMinutes(stop.eta);

            if (inMinutes == null || stop.eta == null) {
                return <FormattedMessage id="delivery_arriving_no_time" />;
            } else if (inMinutes <= -1) {
                const delay = delayInMinutes(stop.eta);
                return <FormattedMessage id="delivery_delay" values={{delay}} />;
            } else if (inMinutes <= 0) {
                return <FormattedMessage id="delivery_arriving_soon" />;
            } else if (inMinutes <= 10) {
                const time = formatRelativeTime(inMinutes, "minute");
                return <FormattedMessage id="delivery_arriving_time" values={{time}} />;
            } else {
                const time = formatTime(new Date(stop.eta));
                return <FormattedMessage id="delivery_arriving_time_at" values={{time}} />;
            }
        case "DELIVERED":
            return <FormattedMessage id="delivery_finished" />;
        case "UNDELIVERED":
            return <FormattedMessage id="delivery_undelivered" />;
        case "REDIRECTED":
            return <FormattedMessage id="delivery_redirected" />;
        case "DELIVERED_TO_PUDO":
            return <FormattedMessage id="delivery_delivered_to_pudo" />;
        case "ARRIVED":
            return <FormattedMessage id="delivery_arrived" />;
        case "CANCELLED":
            return <FormattedMessage id="delivery_cancelled" />;
    }
}
